import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// DEV-35181 забрал отсюда activity-female-tai-chi-walking-v2 и activity-female-walking:
		// они раскатаны в базовые пейволлы, поэтому контроль эксперимента получал бы то же, что
		// treatment. Enrollment на них прекращается — getAppAreaExperiment вернёт null и
		// $absmartly.assign не вызовется (src/funnels/funnels.ts:198-205). Два соответствующих блока
		// в аудитории ABsmartly 3750 стали мёртвыми и чистятся отдельно, вне кода.
		// DEV-35101: девять воронок PRD. Тема карточки — по полу (лиловая женская / синяя мужская),
		// кадр — по теме активности; режим add там, где на базе гифтбокс-попапа нет вовсе.
		// Раскладка и обоснования: см. тикет DEV-35101.
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-replace'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-replace'),
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-replace'),
			},
		},
		// male, activity-male-tai-chi-yoga: эти две базы БЕЗ гифтбокс-попапа, поэтому расширители
		// ADD-режима (fasting-m-add, tai-chi-yoga-m-add) сами ставят флаг giftBoxModal. Младше 50
		// не видят попапа вовсе — treatment остаётся identical control для них.
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/fasting-m-add'),
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-add'),
			},
		},
	},
]

export default config
